import { ErrorMessage, Field, Form, Formik } from "formik";
import React, { useState } from "react";
import PhoneInput from "react-phone-number-input";
import { parsePhoneNumber } from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as Yup from "yup";
import CustomToast from "../Components/CustomToast/CustomToast";
import SignupTestimonials from "../PageComponents/SignupTestimonials";
import { signupToggle } from "../Redux/Actions/dataAction";
import { signUp } from "../Services/api";
import logo from "./../Images/vistaplots-logo.png";

function Signup() {
  const dispatch = useDispatch();

  const [value, setValue] = useState();
  const [consitionChecked, setConditionChecked] = useState(false);
  const navigate = useNavigate();

  const defaultDetails = {
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    phoneCode: "",
    password: "",
  };

  const schema = Yup.object().shape({
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
    password: Yup.string().required("Password is required"),
    firstName: Yup.string().required("First name is required"),
    lastName: Yup.string().required("Last Nname is required"),
  });

  const doSignUp = async (values) => {
    try {
      const s = parsePhoneNumber(value);
      values.phoneCode = s.countryCallingCode;
      values.phoneNumber = s.nationalNumber;
      const signUpResp = await signUp(values);
      dispatch(signupToggle({ data: values }));
      toast(<CustomToast type="success" message={signUpResp.msg} />, {
        autoClose: 3000,
      });
      navigate("/otp");
    } catch (error) {
      toast(<CustomToast type="error" message={error} />, {
        autoClose: 3000,
      });
    }
  };

  return (
    <>
      {/* contact form starts*/}
      <div className="contact">
        <div className="signup w-100">
          <div className="row">
            <div className="col-md-6 order-2 order-md-1">
              <div className="light-pink mt-auto">
                <SignupTestimonials />
              </div>
            </div>

            <div className="col-md-6 order-1 order-md-2">
              <div className="contact-area px-5 py-3 signup-form">
                <div className="signup-logo mb-4">
                <Link to="/">
    <img src={logo} width={65} alt=""/>
    </Link>
                </div>
                <div className="row">
                  <div className="col-lg-12 mb-5 mb-lg-0">
                    <Formik
                      // enableReinitialize={true}
                      initialValues={defaultDetails}
                      validationSchema={schema}
                      onSubmit={(values) => {
                        doSignUp(values);
                      }}
                    >
                      <Form>
                        <div className="contact-form row">
                          <div className="mb-3 col-lg-6">
                            <label className="mb-2">First Name*</label>
                            <Field
                              name="firstName"
                              type="text"
                              className="form-control"
                            />
                            <ErrorMessage
                              name="firstName"
                              render={(msg) => (
                                <div className="text-danger">{msg}</div>
                              )}
                            />
                          </div>
                          <div className="mb-3 col-lg-6">
                            <label className="mb-2">Last Name*</label>
                            <Field
                              name="lastName"
                              type="text"
                              className="form-control"
                            />
                            <ErrorMessage
                              name="lastName"
                              render={(msg) => (
                                <div className="text-danger">{msg}</div>
                              )}
                            />
                          </div>
                          <div className="mb-3 col-lg-12">
                            <label className="mb-2">Email Address*</label>
                            <Field
                              name="email"
                              type="email"
                              className="form-control"
                            />
                            <ErrorMessage
                              name="email"
                              render={(msg) => (
                                <div className="text-danger">{msg}</div>
                              )}
                            />
                          </div>
                          <div className="mb-3 col-lg-12">
                            <label className="mb-2">Phone Number*</label>
                            <PhoneInput
                              value={value}
                              onChange={setValue}
                              required
                            />
                          </div>
                          <div className="mb-3 col-lg-12">
                            <label className="mb-2">Password*</label>
                            <Field
                              name="password"
                              type="password"
                              className="form-control"
                            />
                            <ErrorMessage
                              name="password"
                              render={(msg) => (
                                <div className="text-danger">{msg}</div>
                              )}
                            />
                          </div>
                          <div className="mb-3 col-lg-12 d-flex">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id="exampleCheck1"
                              onChange={(event) => {
                                setConditionChecked(event.target.checked);
                              }}
                            />
                            <label className="form-check-label">
                              By clicking Sign Up, you agree to our{" "}
                              <Link to="">Terms of Use</Link> and confirm that
                              you have read, understood, and agreed to our{" "}
                              <Link to=""> Privacy Policy</Link>.
                            </label>
                          </div>
                          <div className="send-button signup-btn">
                            <button type="submit" disabled={!consitionChecked}>
                              Signup
                            </button>
                            <p>
                              Already have an account?{" "}
                              <Link to="/login">Log in</Link>
                            </p>
                          </div>
                        </div>
                      </Form>
                    </Formik>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* contact form ends */}
    </>
  );
}

export default Signup;
